<template>
  <div style="height: 100%">
    <div class="z-block search-block">
      <div v-if="[0, 10, 20].indexOf(userInfo.role_level) > -1">
        档案导入
        <el-input
          v-model="searchForm.siteName"
          style="width: 300px"
          placeholder="导入.CSV格式档案数据文件"
        ></el-input>
        <el-upload
          class="upload-demo"
          ref="upload"
          :http-request="uploadFunction"
          :show-file-list="false"
          action="string"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">导入</el-button>
        </el-upload>
        <el-button size="small" type="primary" @click="exportTemplate"
          >模板导出</el-button
        >
        <!-- <el-button size="small" style="margin-left:20px;" @click="onSubmit">导出</el-button> -->
      </div>
      <el-form
        :inline="true"
        ref="form"
        :model="searchForm"
        label-width="80px"
        style="margin-top: 15px"
      >
        <span style="height: 40px; line-height: 40px; display: inline-block"
          >档案导出</span
        >
        <el-form-item label="公司名称：">
          <el-select
            v-model="searchForm.customer_id"
            placeholder="请选择"
            @change="setValue"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="站点名称">
          <el-select v-model="searchForm.site_id" placeholder="请选择">
            <el-option
              v-for="item in siteList"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="传感器类型：">
                    <el-select v-model="searchForm.type" placeholder="传感器类型">
                        <el-option label="AE" value="AE"></el-option>
                            <el-option label="TEV" value="TEV"></el-option>
                            <el-option label="UHF" value="UHF"></el-option>
                            <el-option label="MECH" value="MECH"></el-option>
                            <el-option label="HFCT" value="HFCT"></el-option>
                            <el-option label="OZONE" value="OZONE"></el-option>
                            <el-option label="VIBRATION" value="VIBRATION"></el-option>
                            <el-option label="DEVTEMP" value="DEVTEMP"></el-option>
                            <el-option label="ENVTEMP" value="ENVTEMP"></el-option>
                            <el-option label="ENVTH" value="ENVTH"></el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item>
          <!-- <el-button size="small" type="primary" @click="onSubmit">查询</el-button> -->
          <el-button size="small" type="primary" @click="onSubmit"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 20px; display: flex; height: calc(100% - 130px)">
      <div class="z-block file-menu">
        <div class="block-title">
          <span>档案导航</span>
          <el-button
            size="small"
            class="create-btn"
            @click="add({ type: 'customer' })"
            >新建公司</el-button
          >
        </div>
        <div style="height: calc(100% - 50px)" class="left-tree">
          <tree
            ref="tree"
            v-if="showTree"
            :parentId="parentId"
            :currentKey="currentKey"
            :data="treeData"
            :expandOnClickCustomerNodeFlag="false"
            :isDefaultExpandFirst = "isDefaultExpandFirst"
            @add="add"
            @addChild="addChild"
            @del="del"
            @edit="edit"
            @clickNode="clickNode"
          ></tree>
        </div>
        <!-- <el-button size="small" type="primary" @click="add">新建</el-button>
                <el-button size="small">删除</el-button> -->
      </div>
      <div class="z-block menu-info">
        <div class="block-title">
          <span>层级信息和配置</span>
          <el-button style="float: right" @click="handleOperate"
            >编辑</el-button
          >
        </div>
        <div v-if="clickNodeDetailObj.type == 'customer'" class="details-info">
          <p class="details-title">公司信息</p>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">公司名称</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.name }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">行政区域</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{
                  contentDetails.administrative_division
                    ? contentDetails.administrative_division.province +
                      "-" +
                      contentDetails.administrative_division.city +
                      "-" +
                      contentDetails.administrative_division.region
                    : ""
                }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">备注</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.remarks }}
              </div></el-col
            >
          </el-row>
        </div>
        <div v-if="clickNodeDetailObj.type == 'site'" class="details-info">
          <p class="details-title">站点信息</p>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">站点名称</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.name }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">电压等级</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.voltage_level }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">行政区域</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{
                  contentDetails.administrative_division
                    ? contentDetails.administrative_division.province +
                      "-" +
                      contentDetails.administrative_division.city +
                      "-" +
                      contentDetails.administrative_division.region
                    : ""
                }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">站点坐标</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{
                  contentDetails.site_location
                    ? contentDetails.site_location[0] +
                      "," +
                      contentDetails.site_location[1]
                    : ""
                }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">备注</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.remarks }}
              </div></el-col
            >
          </el-row>
        </div>
        <div v-if="clickNodeDetailObj.type == 'equipment'" class="details-info">
          <p class="details-title">设备信息</p>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">设备名称</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.device_name }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">设备类型</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.device_type }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">电压等级</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.voltage_level }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">运行编号</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.operation_number }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">设备编号</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.asset_number }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">设备型号</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.device_model }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">出厂编号</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.factory_number }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">投运时间</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.commissioning_date }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">设备厂家</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.manufacturer }}
              </div></el-col
            >
          </el-row>
          
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">备注</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.remarks }}
              </div></el-col
            >
          </el-row>
        </div>
        <div v-if="clickNodeDetailObj.type == 'point'" class="details-info">
          <p class="details-title">测点信息</p>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">测点名称</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.measure_name }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">传感器编号</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.sensor_number }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">测点类型</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ this.measureTypeFormat(contentDetails.measure_type) }}
              </div></el-col
            >
          </el-row>

          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">是否开启报警屏蔽</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.enable_block_alarm?'是':'否' }}
              </div></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">是否开启报警抑制</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.enable_alarm_restraint?'是':'否' }}
              </div></el-col
            >
          </el-row>
          <el-row v-if="contentDetails.enable_alarm_restraint">
            <el-col :span="5"><div class="grid-content bg-purple">报警抑制条件</div></el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{contentDetails.alarm_restraint_info.alarm_duration}}分钟内触发报警次数达到{{contentDetails.alarm_restraint_info.max_alarm_nums}}条，</div>
               <div class="grid-content bg-purple-light">{{contentDetails.alarm_restraint_info.push_no_alarm_minutes}}分钟内不再推送报警。</div>
            </el-col>
          </el-row>
          <el-row v-if="contentDetails.measure_type != 'MECH' && contentDetails.measure_type != 'MECHSEP' ">
            <el-col :span="5"
              ><div class="grid-content bg-purple">是否开启长期趋势监测</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.enable_long_trend_alarm?'是':'否' }}
              </div></el-col
            >
          </el-row>
          <el-row v-if="contentDetails.measure_type != 'MECH' && contentDetails.measure_type != 'MECHSEP' ">
            <el-col :span="5"
              ><div class="grid-content bg-purple">是否开启短期趋势监测</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.enable_short_trend_alarm?'是':'否' }}
              </div></el-col
            >
          </el-row>
          <el-row v-if="contentDetails.enable_long_trend_alarm">
            <el-col :span="5"><div class="grid-content bg-purple">长期趋势监测条件</div></el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{contentDetails.long_trend_alarm_info.trend_days}}天内，平均放电幅值上升趋势系数大于{{contentDetails.long_trend_alarm_info.warning_thread}}，
               <span v-if="pdValueTypeList.includes(contentDetails.measure_type)">且局放类型占比超过{{contentDetails.long_trend_alarm_info.pd_proportion}}%，</span>
               则推送长期趋势预警数据；平均放电幅值上升趋势大于{{contentDetails.long_trend_alarm_info.alarm_thread}}，
               <span v-if="pdValueTypeList.includes(contentDetails.measure_type)">且局放类型占比超过{{contentDetails.long_trend_alarm_info.pd_proportion}}%，</span>则推送长期趋势报警数据。</div>
            </el-col>
          </el-row>
          <el-row v-if="contentDetails.enable_short_trend_alarm">
            <el-col :span="5"><div class="grid-content bg-purple">短期趋势监测条件</div></el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">{{contentDetails.short_trend_alarm_info.trend_days}}天内，平均放电幅值上升趋势系数大于{{contentDetails.short_trend_alarm_info.warning_thread}}，
               <span v-if="pdValueTypeList.includes(contentDetails.measure_type)">且局放类型占比超过{{contentDetails.long_trend_alarm_info.pd_proportion}}%，</span>
               则推送短期趋势预警数据；平均放电幅值上升趋势大于{{contentDetails.long_trend_alarm_info.alarm_thread}}，
               <span v-if="pdValueTypeList.includes(contentDetails.measure_type)">且局放类型占比超过{{contentDetails.long_trend_alarm_info.pd_proportion}}%，</span>则推送短期趋势报警数据。</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="5"
              ><div class="grid-content bg-purple">备注</div></el-col
            >
            <el-col :span="12"
              ><div class="grid-content bg-purple-light">
                {{ contentDetails.remarks }}
              </div></el-col
            >
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog
      :title="operateType + '公司'"
      :visible.sync="addCompanyDialog"
      :close-on-click-modal="false"
      @close="cancel('addCompanyDialog', 'companyForm')"
      class="dialog-box"
      width="500px"
    >
      <el-form
        :model="companyForm"
        :rules="companyRules"
        label-width="100px"
        ref="companyForm"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="companyForm.name"></el-input>
        </el-form-item>

        <el-form-item label="行政区域" prop="divisionArr">
          <el-cascader
            :options="areaData"
            ref="cascader"
            v-model="divisionArr"
            @change="handleAreaChange"
            @getCheckedNodes="getCheckedNodes"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="companyForm.remarks"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('addCompanyDialog', 'companyForm')"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="save('addCompanyDialog', 'companyForm')"
          >保 存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="operateType + '站点'"
      :visible.sync="addSitetDialog"
      :close-on-click-modal="false"
      @close="cancel('addSitetDialog', 'siteForm')"
      class="dialog-box"
      width="500px"
    >
      <el-form
        :model="siteForm"
        :rules="siteRules"
        label-width="100px"
        ref="siteForm"
      >
        <el-form-item label="站点名称" prop="name">
          <el-input v-model="siteForm.name"></el-input>
        </el-form-item>
        <el-form-item label="电压等级" prop="voltage_level">
          <el-select v-model="siteForm.voltage_level" placeholder="请选择">
            <el-option label="6kV" value="6kV"></el-option>
            <el-option label="10kV" value="10kV"></el-option>
            <el-option label="20kV" value="20kV"></el-option>
            <el-option label="35kV" value="35kV"></el-option>
            <el-option label="66kV" value="66kV"></el-option>
            <el-option label="110kV" value="110kV"></el-option>
            <el-option label="220kV" value="220kV"></el-option>
            <el-option label="330kV" value="330kV"></el-option>
            <el-option label="500kV" value="500kV"></el-option>
            <el-option label="550kV" value="550kV"></el-option>
            <el-option label="750kV" value="750kV"></el-option>
            <el-option label="1000kV" value="1000kV"></el-option>
            <el-option label="±1100kV" value="±1100kV"></el-option>
            <el-option label="±500kV" value="±500kV"></el-option>
            <el-option label="±600kV" value="±600kV"></el-option>
            <el-option label="±800kV" value="±800kV"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行政区域" prop="divisionArr">
          <el-cascader
            :options="areaData"
            ref="cascader"
            v-model="divisionArr"
            @change="handleAreaChange"
            @getCheckedNodes="getCheckedNodes"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="站点坐标" prop="site_location">
          经度
          <el-input
            class="location"
            v-model="siteForm.site_location[0]"
            placeholder="请输入经度"
          />
          纬度
          <el-input
            class="location"
            v-model="siteForm.site_location[1]"
            placeholder="请输入纬度"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="siteForm.remarks"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('addSitetDialog', 'siteForm')"
          >取 消</el-button
        >
        <el-button type="primary" @click="save('addSitetDialog', 'siteForm')"
          >保 存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="operateType + '电力设备'"
      :visible.sync="addDeviceDialog"
      @close="cancel('addDeviceDialog', 'deviceForm')"
      :close-on-click-modal="false"
      class="dialog-box"
      width="500px"
    >
      <el-form
        :model="deviceForm"
        :rules="deviceRules"
        label-width="100px"
        ref="deviceForm"
      >
        <el-form-item label="设备名称" prop="device_name">
          <el-input v-model="deviceForm.device_name"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="device_type">
          <el-select v-model="deviceForm.device_type" placeholder="请选择">
            <el-option label="开关柜" value="开关柜"></el-option>
            <el-option label="GIS" value="GIS"></el-option>
            <el-option label="变压器" value="变压器"></el-option>
            <el-option label="电缆" value="电缆"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电压等级" prop="voltage_level">
          <el-select v-model="deviceForm.voltage_level" placeholder="请选择">
            <el-option label="6kV" value="6kV"></el-option>
            <el-option label="10kV" value="10kV"></el-option>
            <el-option label="20kV" value="20kV"></el-option>
            <el-option label="35kV" value="35kV"></el-option>
            <el-option label="66kV" value="66kV"></el-option>
            <el-option label="110kV" value="110kV"></el-option>
            <el-option label="220kV" value="220kV"></el-option>
            <el-option label="330kV" value="330kV"></el-option>
            <el-option label="500kV" value="500kV"></el-option>
            <el-option label="550kV" value="550kV"></el-option>
            <el-option label="750kV" value="750kV"></el-option>
            <el-option label="1000kV" value="1000kV"></el-option>
            <el-option label="±1100kV" value="±1100kV"></el-option>
            <el-option label="±500kV" value="±500kV"></el-option>
            <el-option label="±600kV" value="±600kV"></el-option>
            <el-option label="±800kV" value="±800kV"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运行编号" prop="operation_number">
          <el-input v-model="deviceForm.operation_number"></el-input>
        </el-form-item>
        <el-form-item label="设备编号" prop="asset_number">
          <el-input v-model="deviceForm.asset_number"></el-input>
        </el-form-item>
        <el-form-item label="设备型号" prop="device_model">
          <el-input v-model="deviceForm.device_model"></el-input>
        </el-form-item>
        <el-form-item label="出厂编号" prop="factory_number">
          <el-input v-model="deviceForm.factory_number"></el-input>
        </el-form-item>
        <el-form-item label="投运时间" prop="commissioning_date">
          <!-- 替换为日期选择器，可根据需求选择仅日期/日期+时间 -->
          <el-date-picker
            v-model="deviceForm.commissioning_date"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择投运时间"
            clearable
            style="width: 100%;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="设备厂家" prop="manufacturer">
          <el-input v-model="deviceForm.manufacturer"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="deviceForm.remarks"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('addDeviceDialog', 'deviceForm')"
          >取 消</el-button
        >
        <el-button type="primary" @click="save('addDeviceDialog', 'deviceForm')"
          >保 存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="operateType + '测点'"
      :visible.sync="addPointDialog"
      :close-on-click-modal="false"
      @close="cancel('addPointDialog', 'pointForm')"
      class="dialog-box"
      width="600px"
    >
      <el-form
        :model="pointForm"
        :rules="pointRules"
        label-width="100px"
        ref="pointForm"
        class="pointForm"
      >
        <el-form-item label="测点名称" prop="measure_name">
          <el-input
            v-model="pointForm.measure_name"
            placeholder="请输入测点名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="测点类型" prop="measure_type">
          <el-select
            v-model="pointForm.measure_type"
            placeholder="请选择"
            :disabled="operateType == '修改'"
            @change="changeSensorType"
          >
            <el-option
              v-for="item in sensorTypeOptions"
              :label="item.label"
              :value="item.type"
              :key="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="传感器编号" prop="sensor_number">
          <!-- <el-select v-model="pointForm.sensor_number"
                      placeholder="请选择"
                      filterable
                      allow-create default-first-option
                      @blur="onTypeBlur($event)">
                        <el-option v-for="(value,key) in sensorNumberArr" :key="key" :value="key">{{ key }}</el-option>
                    </el-select> -->
          <el-autocomplete
            class="inline-input"
            v-model="pointForm.sensor_number"
            :fetch-suggestions="queryFetchSuggestions"
            placeholder="请输入或选择"
            clearable
            style="width: 100%"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="报警屏蔽" prop="enable_block_alarm">
          <el-checkbox-group
            :disabled="pointForm.enable_alarm_restraint"
            v-model="pointForm.enable_block_alarm"
          >
            <el-checkbox :value="false" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="报警抑制" prop="enable_alarm_restraint">
          <el-checkbox-group
            :disabled="pointForm.enable_block_alarm"
            v-model="pointForm.enable_alarm_restraint"
          >
            <el-checkbox :value="false" />
          </el-checkbox-group>
          <template v-if="pointForm.enable_alarm_restraint">
            <div class="alarm-times">
               <!-- @input="handleInput(pointForm.alarm_restraint_info.alarm_duration, 'alarmDuration')" -->
              <el-input
                v-model="pointForm.alarm_restraint_info.alarm_duration"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
                <template #append>
                  <el-select
                    v-model="timeSelectDuration"
                    placeholder="Select"
                    style="width: 75px"
                  >
                    <el-option label="分钟" value="min" />
                    <!-- <el-option label="小时" value="hour" />
                    <el-option label="天" value="day" /> -->
                  </el-select>
                </template>
              </el-input>
              <span>内触发报警次数达到</span>
              <!-- @input="handleInput(pointForm.alarm_restraint_info.max_alarm_nums, 'maxAlarmNums')" -->
              <el-input
                v-model="pointForm.alarm_restraint_info.max_alarm_nums"
                type="number"
                :min="1"
                :max="1000"

                style="width: 80px"
              ></el-input>
              <span>条，</span>
            </div>
            <div>
              <!-- @input="handleInput(pointForm.alarm_restraint_info.push_no_alarm_minutes, 'pushNoAlarmMinutes')" -->
              <el-input
                v-model="pointForm.alarm_restraint_info.push_no_alarm_minutes"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
                <template #append>
                  <el-select
                    v-model="timeSelectMinutes"
                    placeholder="Select"
                    style="width: 75px"
                  >
                    <el-option label="分钟" value="min" />
                    <!-- <el-option label="小时" value="hour" />
                    <el-option label="天" value="day" /> -->
                  </el-select>
                </template>
              </el-input>
              <span>内不再推送报警。</span>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="长期趋势监测" prop="enable_long_trend_alarm" v-show="!['MECH','MECHSEP'].includes(pointForm.measure_type)">
          <el-checkbox-group
            v-model="pointForm.enable_long_trend_alarm"
          >
            <el-checkbox :value="false" />
          </el-checkbox-group>
          <template v-if="pointForm.enable_long_trend_alarm">
            <div class="trend-alarm">
               <!-- @input="handleInput(pointForm.alarm_restraint_info.alarm_duration, 'alarmDuration')" -->
              <span>趋势计算天数：</span>
              <el-input
                v-model="pointForm.long_trend_alarm_info.trend_days"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
            <div class="trend-alarm">
               <!-- @input="handleInput(pointForm.long_trend_alarm_info.alarm_duration, 'alarmDuration')" -->
              <span>预警趋势系数：</span>
              <el-input
                v-model="pointForm.long_trend_alarm_info.warning_thread"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
            <div class="trend-alarm">
               <!-- @input="handleInput(pointForm.long_trend_alarm_info.alarm_duration, 'alarmDuration')" -->
              <span>报警趋势系数：</span>
              <el-input
                v-model="pointForm.long_trend_alarm_info.alarm_thread"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
            <div class="trend-alarm" v-if="pdValueTypeList.includes(pointForm.measure_type)">
               <!-- @input="handleInput(pointForm.long_trend_alarm_info.alarm_duration, 'alarmDuration')" -->
              <span>局放类型占比：</span>
              <el-input
                v-model="pointForm.long_trend_alarm_info.pd_proportion"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="短期趋势监测" prop="enable_short_trend_alarm" v-show="!['MECH','MECHSEP'].includes(pointForm.measure_type)">
          <el-checkbox-group
            v-model="pointForm.enable_short_trend_alarm"
          >
            <el-checkbox :value="false" />
          </el-checkbox-group>
          <template v-if="pointForm.enable_short_trend_alarm">
            <div class="trend-alarm">
               <!-- @input="handleInput(pointForm.long_trend_alarm_info.alarm_duration, 'alarmDuration')" -->
              <span>趋势计算天数：</span>
              <el-input
                v-model="pointForm.short_trend_alarm_info.trend_days"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
            <div class="trend-alarm">
               <!-- @input="handleInput(pointForm.short_trend_alarm_info.alarm_duration, 'alarmDuration')" -->
              <span>预警趋势系数：</span>
              <el-input
                v-model="pointForm.short_trend_alarm_info.warning_thread"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
            <div class="trend-alarm">
               <!-- @input="handleInput(pointForm.short_trend_alarm_info.alarm_duration, 'alarmDuration')" -->
              <span>报警趋势系数：</span>
              <el-input
                v-model="pointForm.short_trend_alarm_info.alarm_thread"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
            <div class="trend-alarm" v-if="pdValueTypeList.includes(pointForm.measure_type)">
               <!-- @input="handleInput(pointForm.short_trend_alarm_info.alarm_duration, 'alarmDuration')" -->
              <span>局放类型占比：</span>
              <el-input
                v-model="pointForm.short_trend_alarm_info.pd_proportion"
                type="number"
                :min="1"
                :max="60 * 24 * 30"
                style="width: 180px"
                placeholder="请输入"

                class="input-with-select"
              >
              </el-input>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="pointForm.remarks"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('addPointDialog', 'pointForm')"
          >取 消</el-button
        >
        <el-button type="primary" @click="save('addPointDialog', 'pointForm')"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tree from "@/components/tree.vue";
import * as device from "@/data/device.js";
import * as file from "@/data/file.js";
import { allData } from "@/util/china.js";
import * as account from "@/data/api.js";
import { sensorTypeOptions, pdValueTypeList } from "@/util/sensorType.js";
export default {
  name: "file",
  components: {
    tree,
  },
  data() {
    const validateOrg = (rule, value, callback) => {
      if (!this.divisionArr.length) {
        callback(new Error("行政区域不能为空"));
      } else {
        callback();
      }
    };
    const validateLocation = (rule, value, callback) => {
      if (!(this.siteForm.site_location[0] && this.siteForm.site_location[1])) {
        callback(new Error("请输入经度和纬度"));
      } else {
        callback();
      }
    };
    return {
      isDefaultExpandFirst: false,
      sensorTypeOptions,
      currentKey: "",
      parentId: "",
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      showTree: false,
      searchForm: {
        site_id: "",
        customer_id: "",
      },
      addCompanyDialog: false,
      addSitetDialog: false,
      addDeviceDialog: false,
      addPointDialog: false,
      companyForm: {
        name: "",
        administrative_division: {},
        remarks: "",
      },
      companyRules: {
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        divisionArr: [
          { type: "array", required: true, validator: validateOrg },
        ],
      },
      siteForm: {
        name: "",
        voltage_level: "",
        administrative_division: {},
        remarks: "",
        site_location: [],
      },
      siteRules: {
        name: [{ required: true, message: "请输入站点名称", trigger: "blur" }],
        voltage_level: [
          { required: true, message: "请选中电压等级", trigger: "change" },
        ],
        divisionArr: [
          { type: "array", required: true, validator: validateOrg },
        ],
        site_location: [
          {
            type: "array",
            required: true,
            validator: validateLocation,
            trigger: "blur",
          },
        ],
      },
      deviceForm: {
        device_name: "",
        device_type: "",
        voltage_level: "",
        operation_number: "",
        asset_number: "",
        device_model: "",
        factory_number: "",
        commissioning_date: "",
        manufacturer: "",
        remarks: "",
      },
      deviceRules: {
        device_name: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        device_type: [
          { required: true, message: "请选中设备类型", trigger: "change" },
        ],
        commissioning_date: [
          { required: true, message: "请选择投运时间", trigger: "change" },
        ],
        // voltage_level: [{ required: true, message: '请选中电压等级', trigger: 'change' }],
        // operation_number: [{ required: true, message: '请输入运行编号', trigger: 'blur' }],
        // asset_number: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        // device_model: [{ required: true, message: '请输入设备型号', trigger: 'blur' }],
        // factory_number: [{ required: true, message: '请输入出厂编号', trigger: 'blur' }],
      },
      timeSelectDuration: "min",
      timeSelectMinutes: "min",
      pointForm: {
        measure_name: "",
        measure_type: "",
        sensor_number: "",
        enable_block_alarm: false,
        enable_alarm_restraint: false,
        enable_long_trend_alarm: false,
        enable_short_trend_alarm: false,
        alarm_restraint_info: {
          alarm_duration: '',
          max_alarm_nums:'',
          push_no_alarm_minutes: ''
        },
        long_trend_alarm_info: {
          trend_days: '',
          warning_thread: '',
          alarm_thread: '',
          pd_proportion: ''
        },
        short_trend_alarm_info: {
          trend_days: '',
          warning_thread: '',
          alarm_thread: '',
          pd_proportion: ''
        },
        remarks: "",
      },
      pointRules: {
        measure_name: [
          { required: true, message: "请输入测点名称", trigger: "blur" },
        ],
        sensor_number: [
          {
            required: true,
            message: "请输入或选择传感器编号",
            trigger: "blur",
          },
        ],
        measure_type: [
          { required: true, message: "请选中测点类型", trigger: "change" },
        ],
      },
      treeData: [],
      clickNodeObj: {}, //当前点击的节点
      clickNodeDetailObj: {}, //当前点击的节点,用于展示详情
      operateType: "", //新增或修改
      actionName: "", //操作（新增同级或新增下级）
      areaData: allData, //区域数据
      selectAreaData: {
        //选中的区域信息
        province: "",
        city: "",
        region: "",
      },
      contentDetails: {},
      divisionArr: [],
      sensorNumberArr: [], //未绑定的传感器编号数组
      customerList: [],
      siteList: [],
      pdValueTypeList: pdValueTypeList
    };
  },
  methods: {
    handleInput(value, target) {
      if (value === "") {
        this[target] = 1;
      } else {
        value = value.replace(/\D/g, ""); // 移除所有非数字字符
        if (target == "maxAlarmNums" && value > 1000) {
          this[target] = 1000;
        } else {
          if (value > 60 * 24 * 30) {
            this[target] = 60 * 24 * 30;
          } else {
            this[target] = value;
          }
        }
      }
    },
    transformTimeToMintue(time, type) {
      if (type === "min") {
        return time;
      } else if (type === "hour") {
        return time * 60;
      } else {
        return time * 60 * 24;
      }
    },
    measureTypeFormat(type) {
      const name = this.sensorTypeOptions.filter((n) => n.type == type)[0]
        .label;
      return name;
    },
    getEquipmentSensor(id) {
      file.getEquipmentSensor({ equipment_id: id }).then((res) => {
        this.sensorNumberArr = res.data.sensor_list.map((item) => {
          item.label = item.sensor_number;
          item.value = item.sensor_data_id;
          return item;
        });
      });
    },
    getSiteSensor(id) {
      file.getSiteSensor({ site_id: id }).then((res) => {
        this.sensorNumberArr = res.data.sensor_list.map((item) => {
          item.label = item.point_name;
          item.value = item.point_id;
          return item;
        });
      });
    },
    exportTemplate() {
      file.fileTemplateExport().then((res) => {
      });
    },
    getCustomerList() {
      account.getCustomerList(this.userForm).then((res) => {
        this.customerList = res.data.customers;
      });
    },
    setValue(v) {
      this.getSiteList(v);
      this.searchForm.site_id = "";
    },
    getSiteList(id) {
      account.siteRequest(id, "get").then((res) => {
        this.siteList = res.data.sites;
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadFunction(item) {
      let formData = new FormData();
      formData.append("file", item.file);
      file
        .importFile({
          data: formData,
        })
        .then((res) => {
          this.$message({ type: "success", message: "导入成功" });
          this.getTreeData();
        });
    },
    onSubmit() {
      //导出
      file.fileExport(this.searchForm).then((res) => {
      });
    },
    handleOperate() {
      this.edit(this.clickNodeDetailObj);
    },
    handleAreaChange(v) {
      let labers = this.$refs.cascader.getCheckedNodes()[0].pathLabels;
      this.$set(this, "divisionArr", labers);
      this.selectAreaData = {
        province: labers[0],
        city: labers[1],
        region: labers[2],
      };
    },
    getCheckedNodes(v) {
    },
    clickNode(v) {
      this.currentKey = v.id;
      this.parentId = v.parent_id;
      this.clickNodeDetailObj = v;
      if (v.type == "customer") {
        file.companyDetails({ customer_id: v.id }).then((res) => {
          this.contentDetails = res.data;
        });
      } else if (v.type == "site") {
        file
          .siteDetails({ customer_id: v.parent_id, site_id: v.id })
          .then((res) => {
            this.contentDetails = res.data;
          });
      } else if (v.type == "equipment") {
        file
          .deviceDetails({ device_id: v.id, site_id: v.parent_id })
          .then((res) => {
            this.contentDetails = res.data;
          });
      } else if (v.type == "point") {
        file
          .pointDetails({ point_id: v.id, equipment_id: v.parent_id })
          .then((res) => {
            this.contentDetails = res.data;
          });
      }
    },
    showDialogFun(obj) {
      switch (obj.type) {
        case "customer":
          this.addCompanyDialog = true;
          break;
        case "site":
          this.addSitetDialog = true;
          break;
        case "equipment":
          this.addDeviceDialog = true;
          break;
        case "point":
          this.addPointDialog = true;
          //  this.getSiteSensor(obj.id)
          break;
        default:
          break;
      }
    },
    add(obj) {
      this.operateType = "新建";
      this.actionName = "add";
      this.clickNodeObj = obj;
      this.showDialogFun(obj);
    },
    addChild(obj) {
      this.operateType = "新建";
      this.actionName = "addChild";
      this.clickNodeObj = obj;
      switch (obj.type) {
        case "customer":
          this.addSitetDialog = true;
          break;
        case "site":
          this.addDeviceDialog = true;
          break;
        case "equipment":
          this.addPointDialog = true;
          //  this.getEquipmentSensor(obj.id)
          break;
        default:
          break;
      }
    },
    changeSensorType(sensor_type) {
      this.queryUnbindSensor(this.contentDetails, sensor_type);
    },
    queryUnbindSensor(obj, sensor_type) {
      let params = {
        data: { sensor_type: sensor_type ? sensor_type : obj.measure_type },
        site_id: obj.site_id,
      };
      file.queryUnbindSensor(params).then((res) => {
        let sensorNumberArr = res.data;
        for (let key in sensorNumberArr) {
          let temp = { value: key };
          this.sensorNumberArr.push(temp);
        }
        if (obj.callQueryFromType && obj.callQueryFromType == "pointEdit") {
          if (this.pointForm.sensor_number != "") {
            let foundObj = this.sensorNumberArr.find(
              (obj) => obj.value === this.pointForm.sensor_number
            );
            if (!foundObj) {
              let temp = { value: this.pointForm.sensor_number };
              this.sensorNumberArr.push(temp);
            }
          }
        }
      });
    },
    queryFetchSuggestions(queryString, cb) {
      let sensorNumberArr = this.sensorNumberArr;
      let foundObj = sensorNumberArr.find(
        (obj) => obj.value === this.pointForm.sensor_number
      );
      let results =
        queryString && !foundObj
          ? sensorNumberArr.filter(
              this.createFetchSuggestionsFilter(queryString)
            )
          : sensorNumberArr;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFetchSuggestionsFilter(queryString) {
      return (item) => {
        return (
          item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    findNode(tree, func) {
      for (const node of tree) {
        if (func(node)) return node;
        if (node.children) {
          const res = this.findNode(node.children, func);
          if (res) return res;
        }
      }
      return null;
    },
    onTypeBlur(e) {
      if (e.target.value) {
        this.pointForm.sensor_number = e.target.value;
      }
    },
    edit(obj) {
      this.operateType = "修改";
      this.clickNodeObj = obj;
      //查询详情
      this.showDialogFun(obj);
      if (obj.type == "customer") {
        file.companyDetails({ customer_id: obj.id }).then((res) => {
          this.valueAssign(this.companyForm, res.data);
          this.selectAreaData = this.companyForm.administrative_division;
          this.divisionArr = [
            this.companyForm.administrative_division.province,
            this.companyForm.administrative_division.city,
            this.companyForm.administrative_division.region,
          ];
        });
      } else if (obj.type == "site") {
        file
          .siteDetails({ customer_id: obj.parent_id, site_id: obj.id })
          .then((res) => {
            this.valueAssign(this.siteForm, res.data);
            this.selectAreaData = this.siteForm.administrative_division;
            this.divisionArr = [
              this.siteForm.administrative_division.province,
              this.siteForm.administrative_division.city,
              this.siteForm.administrative_division.region,
            ];
          });
      } else if (obj.type == "equipment") {
        file
          .deviceDetails({ site_id: obj.parent_id, device_id: obj.id })
          .then((res) => {
            this.valueAssign(this.deviceForm, res.data);
          });
      } else if (obj.type == "point") {
        file
          .pointDetails({ point_id: obj.id, equipment_id: obj.parent_id })
          .then((res) => {
            const {
              alarm_restraint_info,
              enable_alarm_restraint,
              enable_block_alarm,
              measure_name,
              measure_type,
              remarks,
              sensor_number,
              enable_long_trend_alarm,
              long_trend_alarm_info,
              enable_short_trend_alarm,
              short_trend_alarm_info
            } = res.data;
            const pointRes = {
              alarm_restraint_info: alarm_restraint_info,
              enable_alarm_restraint: enable_alarm_restraint,
              enable_block_alarm: enable_block_alarm,
              measure_name: measure_name,
              measure_type: measure_type,
              remarks: remarks,
              sensor_number: sensor_number,
              enable_long_trend_alarm: enable_long_trend_alarm,
              long_trend_alarm_info: long_trend_alarm_info,
              enable_short_trend_alarm: enable_short_trend_alarm,
              short_trend_alarm_info: short_trend_alarm_info
            };
            this.pointForm.measure_name = measure_name
            this.pointForm.measure_type = measure_type
            this.pointForm.sensor_number = sensor_number
            this.pointForm.remarks = remarks
            this.pointForm.enable_block_alarm =  enable_block_alarm
            this.pointForm.enable_long_trend_alarm =  enable_long_trend_alarm
            this.pointForm.long_trend_alarm_info =  long_trend_alarm_info
            this.pointForm.enable_short_trend_alarm =  enable_short_trend_alarm
            this.pointForm.short_trend_alarm_info =  short_trend_alarm_info
            this.pointForm.enable_alarm_restraint =  enable_alarm_restraint
            const { alarm_duration, max_alarm_nums, push_no_alarm_minutes } = alarm_restraint_info;
            if(alarm_duration){
              this.pointForm.alarm_restraint_info.alarm_duration = alarm_duration
            }
            if(max_alarm_nums){
              this.pointForm.alarm_restraint_info.max_alarm_nums = max_alarm_nums
            }
            if(push_no_alarm_minutes){
              this.pointForm.alarm_restraint_info.push_no_alarm_minutes = push_no_alarm_minutes
            }
            let tempObj = res.data;
            tempObj["callQueryFromType"] = "pointEdit";
            this.queryUnbindSensor(tempObj);
          });
      }
    },
    del(obj) {
      this.$confirm(
        "是否清除当前位置的后台数据?【取消删除请点击右上角 X 】",
        "提示",
        {
          confirmButtonText: "清除",
          cancelButtonText: "不清除",
          distinguishCancelAndClose: true,
          type: "warning",
        }
      )
        .then(() => {
          this.delActhon(obj, true);
        })
        .catch((action) => {
          if (action == "cancel") {
            this.delActhon(obj, false);
          } else {
            this.$message({ type: "info", message: "已取消删除" });
          }
        });
    },
    delActhon(obj, n) {
      if (obj.type == "customer") {
        file.delCompany({ customer_id: obj.id, isClear: n }).then((res) => {
          this.delSuccess(obj);
        });
      } else if (obj.type == "site") {
        file
          .delSite({ customer_id: obj.parent_id, site_id: obj.id, isClear: n })
          .then((res) => {
            this.delSuccess(obj);
          });
      } else if (obj.type == "equipment") {
        file
          .delDevice({
            site_id: obj.parent_id,
            equipment_id: obj.id,
            isClear: n,
          })
          .then((res) => {
            this.delSuccess(obj);
          });
      } else if (obj.type == "point") {
        file
          .delPoint({
            equipment_id: obj.parent_id,
            point_id: obj.id,
            isClear: n,
          })
          .then((res) => {
            this.delSuccess(obj);
          });
      }
    },
    delSuccess(obj) {
      if (obj.id == this.clickNodeDetailObj.id) {
        if (this.clickNodeDetailObj.parent_id) {
          const node = this.findNode(this.treeData, (node) => {
            return node.id == this.clickNodeDetailObj.parent_id;
          });
          this.clickNodeDetailObj = node;
        } else {
          this.clickNodeDetailObj = {}; //当前点击的节点被删除后，将当前节点置空
        }
      }
      this.$message({ message: "删除成功", type: "success" });
      this.getTreeData();
    },
    valueAssign(obja, objb) {
      //objb 给对象 obja赋值
      Object.keys(obja).forEach((key) => {
        obja[key] = objb[key] || obja[key];
      });
    },
    getTreeData(addObj) {
      let This = this;
      device.queryTree({ add_point: true }).then((res) => {
        if (!res) return;

        This.treeData = res.data;
        This.showTree = true;
        let node;
        if (addObj) {
          //添加的话
          node = this.findNode(res.data, (node) => {
            return node.id == addObj._id;
          });
        } else {
              const str = sessionStorage.getItem('currentNode')
              if(str){
                  node = JSON.parse(str)
                  this.isDefaultExpandFirst = false;
              }else {
                  node = res.data[0].children[0];
              }
        }
        This.clickNode(node);
        this.searchForm.customer_id = this.searchForm.site_id = ""; //档案树有变更后，清空导出条件重新选
      });
    },
    resetForm(val) {
      this.$refs[val].resetFields();
      this[val].remarks = "";
      if (this[val].site_location) {
        this[val].site_location = [];
      }
      this.divisionArr = [];
      this.sensorNumberArr = [];
    },
    cancel(dia, form) {
      this[dia] = false;
      this.resetForm(form);
    },
    save(val, form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (val == "addCompanyDialog") {
            this.companyForm.administrative_division = this.selectAreaData;
            if (this.operateType == "新建") {
              file.addCompany(this.companyForm).then((res) => {
                this[val] = false;
                this.getTreeData(res.data);
                this.resetForm(form);
                this.$message({ type: "success", message: "添加成功" });
              });
            } else {
              file
                .editCompany({
                  params: this.companyForm,
                  customer_id: this.clickNodeObj.id,
                })
                .then((res) => {
                  this[val] = false;
                  this.getTreeData();
                  this.resetForm(form);
                  this.$message({ type: "success", message: "修改成功" });
                });
            }
          } else if (val == "addSitetDialog") {
            this.siteForm.administrative_division = this.selectAreaData;
            let _id =
              this.actionName == "add"
                ? this.clickNodeObj.parent_id
                : this.clickNodeObj.id;
            if (this.operateType == "新建") {
              file
                .addSite({ parent_id: _id, params: this.siteForm })
                .then((res) => {
                  this[val] = false;
                  this.getTreeData(res.data);
                  this.resetForm(form);
                  this.$message({ type: "success", message: "添加成功" });
                });
            } else {
              file
                .editSite({
                  params: this.siteForm,
                  customer_id: this.clickNodeObj.parent_id,
                  site_id: this.clickNodeObj.id,
                })
                .then((res) => {
                  this[val] = false;
                  this.getTreeData();
                  this.resetForm(form);
                  this.$message({ type: "success", message: "修改成功" });
                });
            }
          } else if (val == "addDeviceDialog") {
            let _id =
              this.actionName == "add"
                ? this.clickNodeObj.parent_id
                : this.clickNodeObj.id;
            // 深拷贝设备表单数据
            const deviceData = JSON.parse(JSON.stringify(this.deviceForm));
            // 转换投运时间格式为ISO 8601
            if (deviceData.commissioning_date) {
              deviceData.commissioning_date = new Date(deviceData.commissioning_date).toISOString();
            }
            if (this.operateType == "新建") {
              file
                .addDevice({ params: deviceData, site_id: _id })
                .then((res) => {
                  this[val] = false;
                  this.getTreeData(res.data);
                  this.resetForm(form);
                  this.$message({ type: "success", message: "添加成功" });
                });
            } else {
              file
                .editDevice({
                  params: deviceData,
                  site_id: this.clickNodeObj.parent_id,
                  equipment_id: this.clickNodeObj.id,
                })
                .then((res) => {
                  this[val] = false;
                  this.getTreeData();
                  this.resetForm(form);
                  this.$message({ type: "success", message: "修改成功" });
                });
            }
          } else if (val == "addPointDialog") {
            let _id =
              this.actionName == "add"
                ? this.clickNodeObj.parent_id
                : this.clickNodeObj.id;
            if (this.operateType == "新建") {
              const pointParams = {
                measure_name: this.pointForm.measure_name,
                measure_type: this.pointForm.measure_type,
                remarks: this.pointForm.remarks,
                sensor_number: this.pointForm.sensor_number,
                enable_block_alarm: this.pointForm.enable_block_alarm,
                enable_alarm_restraint: this.pointForm.enable_alarm_restraint,
                enable_long_trend_alarm:  this.pointForm.enable_long_trend_alarm,
                enable_short_trend_alarm: this.pointForm.enable_short_trend_alarm,
              };
              if (this.pointForm.enable_alarm_restraint) {
                if(!this.pointForm.alarm_restraint_info.alarm_duration
                  || this.pointForm.alarm_restraint_info.alarm_duration == '0'){
                  this.$message({ type: "error", message: "分钟内触发报警次数时间限制不能为空" });
                  return;
                }
                if(!this.pointForm.alarm_restraint_info.max_alarm_nums
                  || this.pointForm.alarm_restraint_info.max_alarm_nums == '0'){
                  this.$message({ type: "error", message: "分钟内触发报警次数不能为空" });
                  return;
                }
                if(!this.pointForm.alarm_restraint_info.push_no_alarm_minutes
                  || this.pointForm.alarm_restraint_info.push_no_alarm_minutes == '0'){
                  this.$message({ type: "error", message: "分钟内不再推送报警时间限制不能为空" });
                  return;
                }
                pointParams.alarm_restraint_info = {
                  alarm_duration: this.transformTimeToMintue(
                    +this.pointForm.alarm_restraint_info.alarm_duration,
                    this.timeSelectDuration
                  ),
                  max_alarm_nums: +this.pointForm.alarm_restraint_info.max_alarm_nums,
                  push_no_alarm_minutes: this.transformTimeToMintue(
                    +this.pointForm.alarm_restraint_info.push_no_alarm_minutes,
                    this.timeSelectMinutes
                  ),
                };
              }
              let validStatus = this.validateTrendParams(pointParams)
              if (!validStatus) {
                return
              }
              file.addPoint({ params: pointParams, device_id: _id }).then((res) => {
                  this[val] = false;
                  this.getTreeData(res.data);
                  this.resetForm(form);
                  this.pointForm.enable_block_alarm = false
                  this.pointForm.enable_alarm_restraint = true
                  this.pointForm.alarm_restraint_info.alarm_duration = 60
                  this.pointForm.alarm_restraint_info.max_alarm_nums = 2
                  this.pointForm.alarm_restraint_info.push_no_alarm_minutes = 1380
                  this.$message({ type: "success", message: "添加成功" });
                });
            } else {
              const pointParams = {
                measure_name: this.pointForm.measure_name,
                measure_type: this.pointForm.measure_type,
                remarks: this.pointForm.remarks,
                sensor_number: this.pointForm.sensor_number,
                enable_block_alarm: this.pointForm.enable_block_alarm,
                enable_alarm_restraint: this.pointForm.enable_alarm_restraint,
                enable_long_trend_alarm:  this.pointForm.enable_long_trend_alarm,
                enable_short_trend_alarm: this.pointForm.enable_short_trend_alarm,
              };
              if (this.pointForm.enable_alarm_restraint) {
                if(!this.pointForm.alarm_restraint_info.alarm_duration
                  || this.pointForm.alarm_restraint_info.alarm_duration == '0'){
                  this.$message({ type: "error", message: "分钟内触发报警次数时间限制不能为空" });
                  return;
                }
                if(!this.pointForm.alarm_restraint_info.max_alarm_nums
                  || this.pointForm.alarm_restraint_info.max_alarm_nums == '0'){
                  this.$message({ type: "error", message: "分钟内触发报警次数不能为空" });
                  return;
                }
                if(!this.pointForm.alarm_restraint_info.push_no_alarm_minutes
                  || this.pointForm.alarm_restraint_info.push_no_alarm_minutes == '0'){
                  this.$message({ type: "error", message: "分钟内不再推送报警时间限制不能为空" });
                  return;
                }
                pointParams.alarm_restraint_info = {
                  alarm_duration: this.transformTimeToMintue(
                    +this.pointForm.alarm_restraint_info.alarm_duration,
                    this.timeSelectDuration
                  ),
                  max_alarm_nums: +this.pointForm.alarm_restraint_info.max_alarm_nums,
                  push_no_alarm_minutes: this.transformTimeToMintue(
                    +this.pointForm.alarm_restraint_info.push_no_alarm_minutes,
                    this.timeSelectMinutes
                  ),
                };
              }
              let validStatus = this.validateTrendParams(pointParams)
              if (!validStatus) {
                return
              }
              file.editPoint({
                  params: pointParams,
                  equipment_id: this.clickNodeObj.parent_id,
                  point_id: this.clickNodeObj.id,
                }).then((res) => {
                  this[val] = false;
                  this.getTreeData();
                  this.resetForm(form);
                  this.pointForm.enable_block_alarm = false
                  this.pointForm.enable_alarm_restraint = true
                  this.pointForm.alarm_restraint_info.alarm_duration = 60
                  this.pointForm.alarm_restraint_info.max_alarm_nums = 2
                  this.pointForm.alarm_restraint_info.push_no_alarm_minutes = 1380
                  this.pointForm.alarm_restraint_info.enable_long_trend_alarm = false
                  this.pointForm.alarm_restraint_info.enable_short_trend_alarm = false
                  this.pointForm.long_trend_alarm_info = {
                    trend_days: '',
                    warning_thread: '',
                    alarm_thread: '',
                    pd_proportion: ''
                  },
                  this.pointForm.short_trend_alarm_info = {
                    trend_days: '',
                    warning_thread: '',
                    alarm_thread: '',
                    pd_proportion: ''
                  },
                  this.$message({ type: "success", message: "修改成功" });
                });
            }
          }
        } else {
          return false;
        }
      });
    },
    validateTrendParams(pointParams){
                if (this.pointForm.enable_long_trend_alarm) {
                if (this.pointForm.long_trend_alarm_info.trend_days <= 7
                 || this.pointForm.long_trend_alarm_info.trend_days > 30
                 || this.pointForm.long_trend_alarm_info.trend_days === '')
                 {
                    this.$message({ type: "error", message: "长期趋势监测中趋势计算天数不能超过30天，并且不能少于8天。" });
                    return;
                 }
                  if (this.pointForm.long_trend_alarm_info.warning_thread === '')
                 {
                    this.$message({ type: "error", message: "长期趋势监测中预警系数不能为空白。" });
                    return;
                 }
                  if (this.pointForm.long_trend_alarm_info.alarm_thread === '')
                 {
                    this.$message({ type: "error", message: "长期趋势监测中报警系数不能为空白。" });
                    return;
                 }
                  if ((this.pointForm.long_trend_alarm_info.pd_proportion < 0
                 || this.pointForm.long_trend_alarm_info.pd_proportion > 100
                 || this.pointForm.long_trend_alarm_info.pd_proportion === '') && this.pdValueTypeList.includes(this.pointForm.measure_type))
                 {
                    this.$message({ type: "error", message: "长期趋势监测中局放类型占比不能低于0，并且不能高于100" });
                    return;
                 }
                 if (this.pdValueTypeList.includes(this.pointForm.measure_type)) {
                  pointParams.long_trend_alarm_info = {
                    trend_days: Number(this.pointForm.long_trend_alarm_info.trend_days) ,
                    warning_thread: Number(this.pointForm.long_trend_alarm_info.warning_thread),
                    alarm_thread: Number(this.pointForm.long_trend_alarm_info.alarm_thread),
                    pd_proportion: Number(this.pointForm.long_trend_alarm_info.pd_proportion)
                  } 
                 }else {
                  pointParams.long_trend_alarm_info = {
                    trend_days: Number(this.pointForm.long_trend_alarm_info.trend_days) ,
                    warning_thread: Number(this.pointForm.long_trend_alarm_info.warning_thread),
                    alarm_thread: Number(this.pointForm.long_trend_alarm_info.alarm_thread)
                  } 
                 }

              }
                if (this.pointForm.enable_short_trend_alarm) {
                if (this.pointForm.short_trend_alarm_info.trend_days <= 0
                 || this.pointForm.short_trend_alarm_info.trend_days > 7
                 || this.pointForm.short_trend_alarm_info.trend_days === '')
                 {
                    this.$message({ type: "error", message: "短期趋势监测中趋势计算天数不能超过30天，并且不能少于8天。" });
                    return;
                 }
                  if ( this.pointForm.short_trend_alarm_info.warning_thread === '')
                 {
                    this.$message({ type: "error", message: "短期趋势监测中预警系数不能为空白。" });
                    return;
                 }
                  if ( this.pointForm.short_trend_alarm_info.alarm_thread === '')
                 {
                    this.$message({ type: "error", message: "短期趋势监测中报警系数不能为空白。" });
                    return;
                 }
                  if (( this.pointForm.short_trend_alarm_info.pd_proportion < 0
                 || this.pointForm.short_trend_alarm_info.pd_proportion > 100
                 || this.pointForm.short_trend_alarm_info.pd_proportion === '') && this.pdValueTypeList.includes(this.pointForm.measure_type))
                 {
                    this.$message({ type: "error", message: "短期趋势监测中局放类型占比不能低于0，并且不能高于100" });
                    return false;
                 }
                 if (this.pdValueTypeList.includes(this.pointForm.measure_type)) {
                    pointParams.short_trend_alarm_info = {
                      trend_days: Number(this.pointForm.short_trend_alarm_info.trend_days) ,
                      warning_thread: Number(this.pointForm.short_trend_alarm_info.warning_thread),
                      alarm_thread: Number(this.pointForm.short_trend_alarm_info.alarm_thread),
                      pd_proportion: Number(this.pointForm.short_trend_alarm_info.pd_proportion)
                    } 
                 } else {
                    pointParams.short_trend_alarm_info = {
                      trend_days: Number(this.pointForm.short_trend_alarm_info.trend_days) ,
                      warning_thread: Number(this.pointForm.short_trend_alarm_info.warning_thread),
                      alarm_thread: Number(this.pointForm.short_trend_alarm_info.alarm_thread)
                    } 
                 }
              }
              return true
    }
  },
  mounted() {
    this.getTreeData();
    this.getCustomerList();
  },
};
</script>

<style lang="less" scoped>
.location {
  width: 40%;
}
.details-info {
  background: #fff;
  padding: 20px;
  .el-row {
    padding: 10px 0;
  }
}
.details-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.trend-alarm {
    // margin-bottom: 10px;
  height: 40px;
  padding: 5px;
  // padding: 20px;
    /deep/.el-input__inner {
      height: 30px !important;    
      }
}
.alarm-times {
  margin-bottom: 10px;
}
/deep/.el-form-item__label {
  width: 100px !important;
}
/deep/.el-form-item__content {
  //    margin-left:100px !important;
}
.create-btn {
  margin-left: 50px;
}
/deep/.left-tree {
  .tree-box .el-tree-node__content:hover {
    // background: #ccc;
    color: #000;
  }
  .tree-box .el-tree-node.is-current > .el-tree-node__content {
    font-weight: bold;
    background-color: #fff;
    color: #409eff;
  }
}
.pointForm {
  /deep/.el-select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/file/file.vue